import React, { useEffect, useState } from "react";
import useStyles from './useStyles';
import UTIL from "../../../../util";
import { Box, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

const CheckTotals = (props) => {
    const { labelsData } = useSelector(state => state);
    const { labels: constants } = labelsData;
    const {
        selectedItem,
        currency = '$',
        suppressTipsOnFireBoard,
    } = props || {};
    const [successTickets, setSuccessTickets] = useState([]);

    useEffect(() => {
        const { tickets } = selectedItem || {};
        if (Array.isArray(tickets) && tickets.length)
            setSuccessTickets(tickets.filter(t => t.ticketStatusId === 1 && t.ticketTypeId === 1));
        else
            setSuccessTickets([]);
    }, [selectedItem]);

    const getTipPercent = () => {
        const { tipAmount, subTotalAmount } = selectedItem;
        let tipPercent = 0;
        if (tipAmount !== 0 && subTotalAmount !== 0) {
            tipPercent = tipAmount / subTotalAmount;
        }
        return tipPercent ? `(${(tipPercent * 100).toFixed(2)}%)` : '';
    };

    const getValue = field => {
        if (selectedItem[field]) {
            return `${currency}${selectedItem[field].toFixed(2)}`;
        }
        return '';
    };

    return (
        <React.Fragment>
            <React.Fragment>
                <AmountDetail label={`${constants.CHECK_DETAILS_SUBTOTAL.toUpperCase()}:`} value={getValue('subTotalAmount')} />
                <AmountDetail label={`${constants.CHECK_DETAILS_TAX}:`} value={getValue('taxAmount')} />
                <AmountDetail label={`${constants.CHECK_DETAILS_DISCOUNT}:`} value={getValue('discountAmount')} />
                <AmountDetail label={`${constants.CHECK_DETAILS_SVC}:`} value={getValue('serviceChargeAmount')} />
                <AmountDetail label={`${constants.CHECK_DETAILS_TOTAL}:`} value={getValue('totalAmount')} />
                <AmountDetail label={`${constants.CHECK_DETAILS_PAID.toUpperCase()}:`} value={getValue('paidAmount')} />
                {suppressTipsOnFireBoard
                    ? null
                    : <AmountDetail label={`${constants.CHECK_DETAILS_TIP}:`} value={`${getValue('tipAmount')} ${getTipPercent()}`} />
                }
                <AmountDetail label={`${constants.CHECK_DETAILS_UNPAID.toUpperCase()}:`} value={getValue('unpaidAmount')} />
            </React.Fragment>
            {successTickets.length > 0
                ? <PaymentMethods tickets={successTickets} currency={currency} />
                : null
            }
        </React.Fragment>
    );
};

export default CheckTotals;

const AmountDetail = ({ label, value }) => {
    const classes = useStyles();
    return (
        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} padding={0.8}>
            <Typography variant='body2' className={classes.amountLabel}>{label}</Typography>
            <Typography variant='body2' className={classes.amountValue}>{value}</Typography>
        </Box>
    );
};

const PaymentMethods = ({ tickets, currency }) => {
    const classes = useStyles();

    const getPaymentInfo = ticket => {
        return {
            paymentType: ticket.cardType ? UTIL.getCardName(ticket.cardType) : UTIL.getPaymentType(ticket.ticketPaymentTypeId),
            name: ticket.TicketPaymentTypeName === 'CreditCard' ? ticket.cardHolderName : '',
            cardNumber: ticket.redactedCardNumber ? ticket.redactedCardNumber.slice(-4) : '',
            amount: ticket.ticketAmount,
        };
    };

    return (
        <Box className={classes.paymentInfoContainer}>
            {Array.isArray(tickets) &&
                tickets.map((ticket, index) => {
                    const paymentInfo = getPaymentInfo(ticket);
                    return (
                        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} paddingLeft={1.2} key={`index-${index}`}>
                            <Typography variant='body2' className={classes.paymentText}>{paymentInfo.paymentType}</Typography>
                            <Typography variant='body2' className={classes.paymentText}>{paymentInfo.name}</Typography>
                            <Typography variant='body2' className={classes.paymentText}>{paymentInfo.cardNumber}</Typography>
                            <Typography variant='body2' className={classes.paymentText}>{currency}{paymentInfo.amount}</Typography>
                        </Box>
                    )
                }
                )}
        </Box>
    );
};
